<template>
<div class="chapter">
<div class="inner_page">
<h1 title="Epigraph"></h1>
<blockquote>
<p class="sectiontop">Generally speaking, all the life which the parents could have lived, but of which they thwarted themselves for artificial motives, is passed on to the children in substitute form. That is to say, the children are driven unconsciously in a direction that is intended to compensate for everything that was left unfulfilled in the lives of their parents.</p>
<p style="text-align:right;">Carl Gustav Jung</p>
</blockquote>
<blockquote>
<p class="first">They fuck you up, your mum and dad,<br/>
    They may not mean to but they do.</p>
<p style="text-align:right;">Philip Larkin</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?4cfb30ea